import React, { useState, useEffect } from "react";
import { useLanguage } from '../contexts/LanguageContext';
import PageBanner from "../components/PageBanner/PageBanner";

import "./Gallery.css";
import { apiCall, API_URL } from '../utils/api';

const Gallery = () => {
  const { t } = useLanguage();
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeFilter, setActiveFilter] = useState("all");
  const [categories, setCategories] = useState([]);
  const [images, setImages] = useState([]);

  // Load categories and images
  useEffect(() => {
    // Categories (static/local for now as per admin page)
    const savedCategories = JSON.parse(localStorage.getItem('galleryCategories') || '[]');
    const enabledCategories = savedCategories
      .filter(cat => cat.enabled)
      .sort((a, b) => a.displayOrder - b.displayOrder);
    setCategories(['all', ...enabledCategories.map(cat => cat.name)]);

    // Images from API
    fetchImages();
  }, []);

  const fetchImages = async () => {
    try {
      const data = await apiCall('/gallery');
      const activeImages = data.filter(img => img.enabled);
      const mapped = activeImages.map(img => ({
        id: img._id,
        category: img.category,
        title: img.title,
        altText: img.altText,
        imageUrl: img.image ? (img.image.startsWith('http') ? img.image : `${API_URL.replace('/api', '')}/${img.image}`) : '',
        displayOrder: img.displayOrder,
        enabled: img.enabled
      }));
      setImages(mapped);
    } catch (error) {
      console.error("Failed to fetch gallery", error);
    }
  };

  const filteredImages =
    activeFilter === "all"
      ? images
      : images.filter((img) => img.category === activeFilter);

  // Stagger animation on load
  useEffect(() => {
    const cards = document.querySelectorAll(".gallery-card");
    cards.forEach((card, index) => {
      card.style.animationDelay = `${index * 0.15}s`;
    });
  }, [activeFilter]);

  return (
    <div className="gallery-page page-fade-in">

      {/* Dynamic Page Banner from Admin */}
      {/* Dynamic Page Banner from Admin */}
      <PageBanner
        pageKey="gallery"
        title={t('gallery.banner.title')}
        subtitle={t('gallery.banner.subtitle')}
      />

      {/* Filters */}
      <div className="filter-container slide-up">
        {categories.map((cat) => (
          <button
            key={cat}
            className={`filter-btn ${activeFilter === cat ? "active-filter" : ""}`}
            onClick={() => setActiveFilter(cat)}
          >
            {cat.toUpperCase()}
          </button>
        ))}
      </div>

      {/* Gallery Grid */}
      <section className="gallery-grid">
        {filteredImages.length > 0 ? (
          filteredImages.map((img, index) => (
            <div
              key={img.id || index}
              className="gallery-card stagger parallax-hover"
              onClick={() => setSelectedImage(img.imageUrl)}
            >
              <div className="shine"></div>
              <img
                src={img.imageUrl}
                alt={img.altText || img.title || t('gallery.default_alt')}
                style={{
                  width: '100%',
                  height: '300px',
                  objectFit: 'cover'
                }}
              />
              {img.title && (
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: 'rgba(0,0,0,0.7)',
                  color: 'white',
                  padding: '10px',
                  fontSize: '14px',
                  textAlign: 'center'
                }}>
                  {img.title}
                </div>
              )}
            </div>
          ))
        ) : (
          <div style={{
            gridColumn: '1 / -1',
            textAlign: 'center',
            padding: '60px 20px',
            color: '#666'
          }}>
            <p style={{ fontSize: '18px', marginBottom: '10px' }}>{t('gallery.no_images')}</p>
            <p style={{ fontSize: '14px' }}>{t('gallery.check_back')}</p>
          </div>
        )}
      </section>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox blur-bg" onClick={() => setSelectedImage(null)}>
          <div className="lightbox-content scale-in">
            <img src={selectedImage} alt="Large" />
            {/* <img src='../assets/images/yoga_1.jpg' alt="Large" /> */}
            <span className="close-btn">✕</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
